import React, { useState, useEffect } from "react";
import axios from "axios";

const DeleteUserData = () => {
    const [outletData, setOutletData] = useState([]);
    const [selectedOutlet, setSelectedOutlet] = useState("");
    const [responseMessage, setResponseMessage] = useState("");

    useEffect(() => {
        const fetchOutlets = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_API}outlates`);
                setOutletData(response.data);
            } catch (error) {
                console.error("Error fetching outlets:", error);
            }
        };
        fetchOutlets();
    }, []);

    const handleOutletChange = (event) => {
        setSelectedOutlet(event.target.value);
        setResponseMessage(""); 
    };

    const deleteUserDataOutletWise = async () => {
        if (!selectedOutlet) {
            setResponseMessage("Please select an outlet.");
            return;
        }

        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_SERVER_API}initialize-outlet?outletId=${selectedOutlet}`
            );

            // Format the API response for display
            const { success, message, deletedRecords } = response.data;
            const formattedMessage = `
                ${message}
                Deleted Records:
                - Bill Master: ${deletedRecords.billMaster}
                - Bill Master History: ${deletedRecords.billMasterHistory}
                - SMS Master: ${deletedRecords.smsMaster}
                - SMS Master History: ${deletedRecords.smsMasterHistory}
            `;

            setResponseMessage(formattedMessage);
        } catch (error) {
            setResponseMessage("Error deleting data. Please try again.");
            console.error("Error deleting data:", error);
        }
    };

    return (
        <div>
            <h1 style={{ whiteSpace: "pre-line" }}>{responseMessage}</h1>
            <div>
                <select className="form-select" onChange={handleOutletChange} value={selectedOutlet}>
                    <option value="" disabled>Select Outlet</option>
                    {outletData.map((outlet) => (
                        <option key={outlet._id} value={outlet.Outlate_Id}>
                            {outlet.Outlet_Name}
                        </option>
                    ))}
                </select>
                <button className="btn btn-danger mt-3" onClick={deleteUserDataOutletWise}>
                    Delete User Data
                </button>
            </div>
        </div>
    );
};

export default DeleteUserData;
